import SliderPage from "./hoc/SliderPage";
import { Col, Row } from "react-bootstrap";
import { BlockCheckbox } from "../components/fields";
import { useBundleContext } from "../context/BundlesContext";
import { toCurrency } from "../helpers";
import { useInSqftRange } from "../hooks";

export const BundlePage = () => {
  const { bundles, onSelect } = useBundleContext();
  const inSqftRange = useInSqftRange();
  const handleChange = (_event, change, sku) => {
    onSelect(sku, change);
  };
  const available_bundles = bundles.filter(({ sqft_range }) =>
    inSqftRange(sqft_range)
  );
  return (
    <SliderPage title="Bundles">
      <Row>
        {available_bundles.map((bundle) => {
          return (
            <Col key={bundle.sku} sm={4} className="mb-5">
              <BlockCheckbox
                label={bundle.name}
                sku={bundle.sku}
                col={false}
                onChange={handleChange}
                custom_price={`${toCurrency(bundle.subtotal, "+")}`}
                discount={`${toCurrency(bundle.total, "+")}`}
                description={bundle.description}
              />
            </Col>
          );
        })}
      </Row>
    </SliderPage>
  );
};
